module.exports = __webpack_public_path__ + "static/media/icon_gridcredits.24a67d40.svg";